export default __webpack_public_path__ + "static/media/apax.b194b78f.svg";